import { defineMessages } from 'react-intl';

export default defineMessages({
  DataGridSearchFieldPlaceholder: {
    defaultMessage: 'Search...',
    description: 'DataGrid search field - placeholder',
    id: 'dataGridSearchField.placeholder',
  },
});
